
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);


export default Icon
